import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { removeAuthObjects } from "../../utils";
import logo from "../../assets/img/logo.png";

export default function MainContainer(props) {
  const handleLogout = () => {
    removeAuthObjects();
    props.history.push("/login");
  };

  return (
    <Box sx={{ minHeight: "100vh", background: "#0A0E1A" }}>
      <AppBar
        position="fixed"
        sx={{
          background: "#0A0E1A",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          boxShadow: "none",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", minHeight: "64px !important" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box component="img" src={logo} alt="MusiLinks" sx={{ width: 28, height: 28, objectFit: 'contain' }} />
            <Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                  background: "linear-gradient(135deg, #9C27B0, #E91E63)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                MusiLinks
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.5rem",
                  color: "#FFFFFF",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  lineHeight: 1,
                }}
              >
                a fronic media product
              </Typography>
            </Box>
          </Box>

          <Button
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
            sx={{
              color: "#FF6B6B",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.85rem",
              "&:hover": {
                background: "rgba(255,107,107,0.1)",
              },
            }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ pt: "64px" }}>
        {props.children}
      </Box>
    </Box>
  );
}
